export default "__VITE_ASSET__gwcJKO3Z__"